/** Workflow detail page tab values (URL `search.tab`). */
export const WORKFLOW_DETAIL_TABS = [
  'description',
  'workflow-diagram',
  'usage-stats',
  'history',
  'evaluations',
] as const

export type WorkflowDetailTab = (typeof WORKFLOW_DETAIL_TABS)[number]

export const DEFAULT_WORKFLOW_DETAIL_TAB: WorkflowDetailTab = 'description'

export function parseWorkflowDetailTab(raw: unknown): WorkflowDetailTab {
  return typeof raw === 'string' && (WORKFLOW_DETAIL_TABS as readonly string[]).includes(raw)
    ? (raw as WorkflowDetailTab)
    : DEFAULT_WORKFLOW_DETAIL_TAB
}
